import type { ProductSet } from 'src/graphql/generated';

export const getSelectedProduct = (
  selectedProductId?: string,
  productSet?: ProductSet | null,
) =>
  productSet?.items?.find((item) =>
    item ? item.id === selectedProductId : null,
  );
